import { createSlice, PayloadAction, createAsyncThunk, AsyncThunkPayloadCreator } from '@reduxjs/toolkit'
import { SearchFilters, SearchResult } from '../../interfaces/Search'
import { SliceStatus } from '../../interfaces/Redux'

import { get } from '../../services/http'
import routeListen from '../../services/routeListen'

interface WorkspaceFilters {
  [key:string] : SearchFilters
}

function getStickyfilters(name: string) {
  const filterName = `${localStorage.getItem('userId')}-${name}`
  return window.localStorage.getItem(filterName) ? JSON.parse(window.localStorage.getItem(filterName) as string) as string[] : []
}


export interface SearchState {
    searchResults: SearchResult[]
    currentSkip: number
    totalResults: number
    isLoading: boolean
    searchActive: boolean,
    workspace: string,
    lastFilters: WorkspaceFilters
    status: SliceStatus
}

export const defaultFilters = {
  searchTerm: '', 
  typeFilter: [],
  dateFilter: '',
  languageFilter: getStickyfilters('preferedSearchLanguages'),
  rulesFilter: getStickyfilters('preferedSearchRules')
}

const initialState: SearchState = {
    searchResults: [],
    currentSkip: 0,
    totalResults: 0,
    isLoading: false,
    searchActive: false,
    workspace: '',
    lastFilters: {},
    status: SliceStatus.idle
}

export const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    resetSearch: (state) => {
      return initialState;
    },
    clearSearch: (state, action) => {
      state.searchResults= [];
      state.currentSkip= 0;
      state.totalResults= 0;
      state.isLoading= false,
      state.searchActive = false,
      state.workspace= '',
      state.lastFilters[routeListen.appGuid()] = {
        ...defaultFilters,
        searchTerm: action.payload.preserveSearch ? state.lastFilters[routeListen.appGuid()]?.searchTerm : '',
        languageFilter: getStickyfilters('preferedSearchLanguages'),
        rulesFilter: getStickyfilters('preferedSearchRules')
      }
    },
    clearFilters: (state) => {
      state.lastFilters[routeListen.appGuid()] = {
        searchTerm: state.lastFilters[routeListen.appGuid()].searchTerm, 
        typeFilter: [],
        dateFilter: '',
        languageFilter: state.lastFilters[routeListen.appGuid()].languageFilter,
        rulesFilter: []
      }
    },
    
    setWorkspace: (state, action) => {
        state.workspace = action.payload
    },

    setParams: (state, action) => {
      state.lastFilters[routeListen.appGuid()] = {
        searchTerm: action.payload.SearchTerm  ? action.payload.SearchTerm : '',
        typeFilter: action.payload.ContentTypes ? action.payload.ContentTypes : [],
        dateFilter: action.payload.Since ? action.payload.Since : '',
        languageFilter: action.payload.LanguageTags ? action.payload.LanguageTags : getStickyfilters('preferedSearchLanguages'),
        rulesFilter: action.payload.Rules ? action.payload.Rules : getStickyfilters('preferedSearchRules')
      }
    }
  },
  extraReducers(builder) {
    builder
      .addCase(getResults.pending, (state, action) => {
        state.isLoading = true
        state.status = SliceStatus.loading
      })
      .addCase(getResults.fulfilled, (state, action) => {
        if(action.payload) {
          state.searchResults = action.payload.items;
          state.currentSkip = action.payload.nextSkip;
          state.totalResults = action.payload.totalItemCount
          state.isLoading = false
        }
        state.status = SliceStatus.succeeded
        
      })
      .addCase(getResults.rejected, (state, action) => ({
        ...initialState,
        status: SliceStatus.failed
      }))
      .addCase(getNextResults.pending, (state, action) => {
        state.isLoading = true
        state.status = SliceStatus.loading
      })
      .addCase(getNextResults.fulfilled, (state, action) => {
        if(action.payload) {
          state.searchResults = [...state.searchResults, ...action.payload.items];
          state.currentSkip = action.payload.nextSkip;
          state.totalResults = action.payload.totalItemCount
          state.isLoading = false
        }
        state.status = SliceStatus.succeeded
        
      })
      .addCase(getNextResults.rejected, (state, action) => ({
        ...initialState,
        status: SliceStatus.failed
      }))
  }
})

export const getResults = createAsyncThunk('search/getResults', async (searchParams: {SearchTerm: string, MediaKindFilters: string[], Since: string, LanguageTags: string[], Rules: any[],  appGuid?: string}) => {
    if(!searchParams.SearchTerm) { 
        return {
          items: [],
          nextSkip: 0,
          totalItemCount: 0
        }
    }
    const appguid = routeListen.appGuid()

    delete searchParams['appGuid']

    const response = await get(`api/search/app/${appguid}/content`, {params: {...searchParams, boostedIetfLanguageTag:window.navigator.language}})

    return response.data;

});

export const getNextResults = createAsyncThunk('search/getNextResults', async (searchParams: {SearchTerm: string, MediaKindFilters: string[], Since: string, LanguageTags: string[], Rules: string[], Top: number, Skip: number}) => {
  const appguid = routeListen.appGuid()

  const response = await get(`api/search/app/${appguid}/content`, {params: {...searchParams, boostedIetfLanguageTag:window.navigator.language}})

  return response.data;

});

// Action creators are generated for each case reducer function
export const { clearSearch, setParams, setWorkspace, clearFilters, resetSearch } =  searchSlice.actions


export default searchSlice.reducer



